import PointerEvents from "../../const/PointerEvents";
import { Tween } from "../../Tween";
import BaseView from "../BaseView";
import SoundController from "../../utils/SoundController";
import SoundVars from "../../const/SoundVars";
import BitmapTextField from "./BitmapTextField";
import TextField from "./TextField";
import { Sprite, Text } from "pixi.js";

/**
 * Checkbox UI element
 */
export default class Checkbox extends BaseView
{

    protected bg: Sprite;
    protected check: Sprite;
    protected selected: boolean;
    protected label: Text | BitmapTextField | TextField;

    // TODO implement default
    constructor(bg: Sprite, check: Sprite, label: Text | BitmapTextField | TextField)
    {
        super();

        this.bg = bg;
        // this.addChild(this.bg);
        this.check = check;
        // this.addChild(this.check);
        this.check.alpha = 0;
        this.bg.interactive = true;
        this.bg.on(PointerEvents.DOWN, this.toggle, this);
        this.selected = false;
        
        this.label = label;
        this.label.interactive = true;
        this.label.on(PointerEvents.DOWN, this.toggle, this);
    }

    public get value():boolean {
        return this.selected;
    }

    public setIsSelected(isSelected)
    {
        this.selected = isSelected;
        this.check.alpha = Number(this.selected);
    }

    public isSelected()
    {
        return this.selected;
    }

    protected toggle()
    {
        SoundController.playSound(SoundVars.BUTTON_CLICK);
        this.selected = !this.selected;
        Tween.to(this.check, .25, {alpha: Number(this.selected)});
        this.emit(PointerEvents.UPDATE);
    }

}
